/* STORIA: automatic direction for customer-facing text.
   Hebrew/Arabic first strong character => RTL; Latin first strong character => LTR.
   dir="auto" uses the browser's Unicode bidi algorithm and also handles dynamic sections. */
(() => {
  const SELECTOR = [
    'h1','h2','h3','h4','h5','h6','p','blockquote','figcaption','li','dt','dd','label','legend','summary','button','a',
    '.rte > *','[class*="heading"]','[class*="title"]','[class*="subtitle"]','[class*="text"]','[class*="description"]','[class*="caption"]','[class*="label"]'
  ].join(',');

  const SKIP = 'script,style,code,pre,svg,math,input,textarea,select,option,[contenteditable="true"],[data-no-auto-dir]';

  function apply(root = document) {
    const nodes = root.nodeType === 1 && root.matches?.(SELECTOR)
      ? [root, ...root.querySelectorAll(SELECTOR)]
      : [...root.querySelectorAll?.(SELECTOR) || []];

    for (const el of nodes) {
      if (el.matches(SKIP) || el.closest('code,pre,svg,math,[data-no-auto-dir]')) continue;
      if (!el.textContent || !el.textContent.trim()) continue;
      el.setAttribute('dir', 'auto');
    }
  }

  const start = () => {
    apply(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') apply(record.target.parentElement || document);
        for (const node of record.addedNodes) if (node.nodeType === 1) apply(node);
      }
    });
    observer.observe(document.body, {subtree:true, childList:true, characterData:true});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
